// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-expansion-panel[data-v-11138a85]{border-radius:15px!important;-webkit-box-shadow:8px 5px 10px #f49d1a;box-shadow:8px 5px 10px #f49d1a}.v-expansion-panel[data-v-11138a85] .v-expansion-panel-header.v-expansion-panel-header--active{background-color:#001554!important;border-radius:15px!important;color:#f5f5f5!important}.v-expansion-panel[data-v-11138a85] .v-expansion-panel-header.v-expansion-panel-header--active .v-icon{color:#f5f5f5!important}", ""]);
// Exports
module.exports = exports;
